import React, {Component} from 'react'
import {authenticationService} from "../../../services/AuthenticationService";
import '../../../style/main.css'
import {history} from "../../../utils/history";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {appendIchilovQuery} from "../../../utils/routeUtils";

class RoutePatientToDashboardComposed extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {

        let search = history.location.search
        if (search) {
            search = search.substring(1)
            let searchArr = search.split('&')
            let patientID = searchArr[1].substring(10)
            let token = searchArr[0].substring(6)
            let lang = searchArr[2].substring(5)
            localStorage.setItem("language",lang)
            if (token && patientID) {
                let response = await authenticationService.getPatientFromRoute( token, patientID)
                let data = response.data
                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    let patientInfo = data
                    history.push({
                        pathname: appendIchilovQuery(`/pain_patient_self_onboard`),
                        state: {
                            patientInfo,
                            from: {
                                fromPath: `/pain_patientRoute`,
                            }
                        },
                    })
                }
            }
        }

    }


    render() {
        return (
            <div/>

        )
    }
}
let RoutePatientToDashboard = compose(
    withTranslation()
)(RoutePatientToDashboardComposed)

export default RoutePatientToDashboard;
